import React, { Component, Fragment } from 'react';
import PageTitle from "../../PageTitle";
import {StagedRolloutSummary} from "../../../models/StagedRolloutSummary";
import Table, {TableColumn} from "../../Table";
import ShortcutterInfo from "../../ShortcutterInfo";
import Playlist from "../../../models/Playlist";
import {PlaylistDefinitionTable} from "./PlaylistDefinitionTable";
import {WorkloadDefinitionTable} from "./WorkloadDefinitionTable";
import {WorkloadInfo} from "../../../models/WorkloadInfo";
import {ICDBPageProps} from "../../../utils/ICDBPageProps";

interface AdminInfoPageProps extends ICDBPageProps
{
}

interface AdminInfoPageState {
    playlists?: Playlist[];
    workloadInfos?: WorkloadInfo[];
    stagedRolloutSummaries?: StagedRolloutSummary[]; 
}


const stagedRolloutColumns: TableColumn[] = [
    {
        title: "Tenant Id",
        propertyPath: "tenantId",
        flex: 3,
        enableSort: true
    },
    {
        title: "Is rolled out",
        propertyPath: "value",
        flex: 1,
        enableSort: true
    }
];

export default class AdminInfoPage extends Component<AdminInfoPageProps, AdminInfoPageState> {
    static displayName = AdminInfoPage.name;
    
    constructor(props: AdminInfoPageProps) {
        super(props);

        this.state = {
            stagedRolloutSummaries: undefined
        }
    }

    async componentDidMount() {
        const stagedRolloutSummaries = await this.props.apiService.getStagedRolloutSummaries();
        this.setState({stagedRolloutSummaries});
        
        const workloadInfos = await this.props.apiService.getWorkloads();
        const playlists = await this.props.apiService.getPlaylists();
        
        this.setState({
            workloadInfos,
            playlists
        });
        
    }

    async componentDidUpdate(prevProps: Readonly<AdminInfoPageProps>, prevState: any): Promise<void> {
        
    }
    
    render() {
        
        const stagedRolloutTables = this.state.stagedRolloutSummaries?.map((summary: StagedRolloutSummary) => {
            return (
                <Table key={summary.name} title={`${summary.name} Rollout (~${summary.targetPercentage}%)`} items={summary.tenantValues} columns={stagedRolloutColumns}/>
            );
        });
        
        return (
            <Fragment>
                <PageTitle title={"Admin Info"}/>
                <PlaylistDefinitionTable playlists={this.state.playlists} />
                <WorkloadDefinitionTable workloadInfos={this.state.workloadInfos} />
                <ShortcutterInfo/>
                {stagedRolloutTables}
            </Fragment>
        );
    }
}